export enum TaxRateTypes {
	//TABLE Ref_TaxRateTypes

	Goods = 1,
	Service = 2,
	Food = 3,
}

export enum TaxRateTypesDescription {
	Goods = 'Goods',
	Service = 'Service',
	Food = 'Food',
}
